// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2P_sI","productName":"Table_productName__3e61j"};